<template>
    <v-fab-transition>
        <!-- outline
        color="#ff7100" -->
        <v-btn
        class="ma-2"
        fab 
        dark 
        small 
        fixed 
        left
        bottom
        
        v-scroll:#app="onScroll"
        v-scroll="onScroll"

        v-show="(offsetTop > 250) || (wrapScroll > 250)"

        @click.stop.prevent = "goToTop"
        
        >
            Up <!-- {{ offsetTop }} {{wrapScroll}} -->
        </v-btn>
    </v-fab-transition>
</template>

<script>
  export default {
    props: ['isMobile'],
    data: () => ({
      offsetTop: 0,
      wrapScroll: 0,
      target: "#app"
    }),

    methods: {
      onScroll (e) {
        this.offsetTop = window.scrollY.toFixed();
        if (this.isMobile) {
            this.wrapScroll = e.target.scrollTop;
            this.target = e.target;
        }
      },

      goToTop() {
        if (this.isMobile) {
            this.target.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
        } else {
            this.$vuetify.goTo(0);
        }
      }
    }
  }
</script>

<style scoped>
    .v-btn {
        border: 2px solid #ff7100;
    }
</style>